@if (symbolStatus === SymbolStatus.HALTED) {
  <div class="td-wb-red td-wb-ticker-symbol-warnings">
    <td-wb-icon class="td-wb-ticker-symbol-warnings__icon"
                size="11"
                [inline]="true"
                iconId="circle-error" />
    <span translate="tdWb.tickerSymbol.messages.HALTED"></span>
  </div>
}

<!--SYMBOL ERROR (an expired option is considered in this case since it is invalid) -->
@if (symbolStatus === SymbolStatus.INVALID) {
  <div class="td-wb-red td-wb-ticker-symbol-warnings">
    <td-wb-icon class="td-wb-ticker-symbol-warnings__icon"
                size="11"
                [inline]="true"
                iconId="circle-error" />
    <span translate="tdWb.tickerSymbol.messages.SYMBOL_ERR"></span>
  </div>
}

@if (symbolStatus === SymbolStatus.QUOTE_ERROR) {
  <div class="td-wb-red td-wb-ticker-symbol-warnings">
    <td-wb-icon class="td-wb-ticker-symbol-warnings__icon"
                size="11"
                [inline]="true"
                iconId="circle-error" />
    <span translate="tdWb.tickerSymbol.messages.QUOTE_MSG_ERR"></span>
  </div>
}

@if (symbolStatus === SymbolStatus.UNSIGNED_AGREEMENT) {
  <div class="td-wb-ticker-symbol-warnings">
    <td-wb-icon iconId="warning--small"
                size="11"
                class="td-wb-ticker-symbol-warnings__icon" />
    <span translate="tdWb.tickerSymbol.messages.REALTIME_QUOTES_1"></span>
    <a class="td-wb-link--underlined"
       tdWbHref="link_preferences_agreements"
       translate="tdWb.tickerSymbol.messages.REALTIME_QUOTES_2"></a>
    <span translate="tdWb.tickerSymbol.messages.REALTIME_QUOTES_3"></span>
  </div>
}
